// src/hooks/useUpdates.js
import { useQuery } from "@tanstack/react-query";
import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";

/**
 * Hook to get project updates (digest tasks + progress photos)
 * Used by the Client Updates page
 * @param {string} projectId - The project ID to fetch updates for
 */
export function useProjectUpdates(projectId) {
  return useQuery({
    queryKey: ["project-updates", projectId],
    queryFn: async () => {
      const getProjectUpdates = httpsCallable(functions, "getProjectUpdates");
      const result = await getProjectUpdates({ projectId });
      return result.data;
    },
    enabled: !!projectId,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
}

/**
 * Hook to get digest tasks only
 * @param {string} projectId - The project ID
 */
export function useDigestTasks(projectId) {
  return useQuery({
    queryKey: ["digest-tasks", projectId],
    queryFn: async () => {
      const getDigestTasks = httpsCallable(functions, "getDigestTasks");
      const result = await getDigestTasks({ projectId });
      return result.data;
    },
    enabled: !!projectId,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
}

/**
 * Hook to get progress photos only
 * @param {string} projectId - The project ID
 */
export function useProgressPhotos(projectId) {
  return useQuery({
    queryKey: ["progress-photos", projectId],
    queryFn: async () => {
      const getProgressPhotos = httpsCallable(functions, "getProgressPhotos");
      const result = await getProgressPhotos({ projectId });
      return result.data;
    },
    enabled: !!projectId,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
}
